




























































































































































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import SwLoginLeftLoginPanel from './sw-login-left-login-panel.vue';
import SwLoginEagle from './sw-login-eagle.vue';
import { LoginModel } from '../interfaces/sw-login-interfaces';
import { SwMessageContainer } from '@libs-uuif/shared/message-service';
import { State } from 'vuex-class';
import { SwBlockingProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-blocking-progress';
import { RootStoreState } from '@/store';

const cssPrefix = 'sw-login';
@Component({
  components: {
    SwLoginLeftLoginPanel,
    SwLoginEagle,
    SwMessageContainer,
    SwBlockingProgress,
  },
})
export default class SwLogin extends SwExtendedVue {
  cssPrefix = cssPrefix;
  skipAnimationEnabled = false;
  showBrowserReq = false;
  showSupportedBrowser: boolean = false;
  cscSecURL = 'https://securitynews.sonicwall.com/capture-cloud-security-center';
  skipAnimation () {
    this.skipAnimationEnabled = true;
  }
  @State((state: RootStoreState) => state.CoreStoreModule.loading)
  visible:boolean;

  @Prop({ required: true })
  value: LoginModel;

  @Prop({ default: false })
  flatEdge: boolean;
  links = [
    {
      title: this.$t('spog.cgmsLinks.link1')
      .toString(),
      text: this.$t('spog.cgmsLinks.link1Text')
      .toString(),
      color: '#48B5C3',
      href: 'browserreq',
    },
    {
      title: this.$t('spog.cgmsLinks.linkLast')
      .toString(),
      text: this.$t('spog.cgmsLinks.linkLastText')
      .toString(),
      color: '#C68DBA',
      href: 'https://www.sonicwall.com/en-us/products/management-and-reporting/capture-security-center',
    },
    {
      title: this.$t('spog.cgmsLinks.link2')
      .toString(),
      text: this.$t('spog.cgmsLinks.link2Text')
      .toString(),
      color: '#BADB77',
      href: '/muir/spog/login?showdemo=yes',
    },
  ];

  created() {
    document.addEventListener('keyup', (event) => {
      if (event.keyCode === 27) {
        this.showBrowserReq = false;
      }
    });
  }
  passLogin(event: any) {
    this.$emit('loginCheck', event);
  }
  openUrl(href : any) {
    if (href === 'browserreq') this.showBrowserReq = !this.showBrowserReq;
    else if (href === 'supportedBrowser') this.showSupportedBrowser = !this.showSupportedBrowser;
    else window.open(href, '_blank');
  }
  browserDivClicked(event : any) {
    console.warn(event);
  }
  hideCscSlider() {
    this.showBrowserReq = false;
  }
  hideBrowserSlider() {
    this.showSupportedBrowser = false;
  }
}
